//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import difference from 'lodash/difference';
import debounce from 'lodash/debounce';

export default {
    props: ['filters'],
    data() {
        return {
            selected: [],
            debouncedUpdateFilter: debounce(this.updateFilter, 1000),
        };
    },
    computed: {
        filteredSelectedFilters() {
            const blackList = ['sortType', 'currentPage', 'pageSize', 'sortDir', 'q'];

            return this.selected.filter((item) => {
                const [code] = item.split('-');

                return !blackList.includes(code);
            });
        },
        blackListed() {
            return this.filters.filter((item) => item.attribute_code !== 'category_uid' && !item.label.includes('_bucket'));
        },
        filterParams() {
            const filters = {};
            this.selected.forEach((item) => {
                const split = item.split('-');
                if (!filters[split[0]]) {
                    filters[split[0]] = [split[1]];
                } else {
                    const newFilter = filters[split[0]];
                    newFilter.push(split[1]);
                    filters[split[0]] = newFilter;
                }
            });

            if (this.$route.query.q) {
                filters.q = this.$route.query.q;
            }
            return filters;
        },
        initialPriceRange() {
            const priceFilter = this.filters.find((item) => item.attribute_code === 'price');
            let allValues = new Set();
            let min = 0;
            let max = 0;
            priceFilter?.options.forEach((item) => {
                const { value } = item;
                if (value.includes('_')) {
                    const [min, max] = value.split('_');
                    allValues.add(min);
                    allValues.add(max);
                }
            });
            if (allValues.size !== 0) {
                min = Math.min(...allValues);
                max = Math.max(...allValues);
            }
            return { min, max };
        },
        priceSliderKey() {
            const baseKey = `${this.initialPriceRange.min}_${this.initialPriceRange.max}`;
            return baseKey;
        },
    },
    mounted() {
        this.$root.$on('quicksearch', this.removeAllFilters);

        Object.keys(this.$route.query).forEach((item) => {
            if (typeof this.$route.query[item] === 'string' || this.$route.query[item] === null) {
                this.selected.push(`${item}-${this.$route.query[item]}`);
            } else if (typeof this.$route.query[item] === 'object') {
                this.$route.query[item].forEach((queryItem) => {
                    this.selected.push(`${item}-${queryItem}`);
                });
            }
        });
    },
    watch: {
        selected(newVal, oldVal) {
            let lastSelectedAttribute = null;
            const filteredNewVal = this.getValidSelectedFilters(newVal);
            const filteredOldVal = this.getValidSelectedFilters(oldVal);

            //Do nothing for the initial load of the page
            if (filteredNewVal.length === 0 && filteredOldVal.length === 0) {
                return;
            }

            // If all filters are disselected, set the last selected attribute to be null
            if (filteredNewVal.length === 0) {
                this.$store.dispatch('attributeFilter/updateLastSelectedAttribute', lastSelectedAttribute);
                return;
            }

            if (filteredOldVal.length <= filteredNewVal.length) {
                lastSelectedAttribute = difference(filteredNewVal, filteredOldVal)[0]?.split('-')[0];
            } else if (filteredOldVal.length > filteredNewVal.length) {
                lastSelectedAttribute = difference(filteredOldVal, filteredNewVal)[0]?.split('-')[0];
            }
            lastSelectedAttribute && this.$store.dispatch('attributeFilter/updateLastSelectedAttribute', lastSelectedAttribute);
        },
    },
    methods: {
        getFilterLabel(filter) {
            if (filter.label === 'Price') {
                return 'Hinta';
            }
            return filter.label;
        },
        getFilterNameAndValue(filter) {
            const [code, value] = filter.split('-');
            let valueLabel = null;
            if (code === 'price') {
                valueLabel = value.includes('_') ? value.replace('_', ' - ') : value;
            } else {
                if (this.filters) {
                    this.filters
                        .filter((item) => item.attribute_code === code)
                        .filter((item) => {
                            return item.options.filter((option) => {
                                if (option.value === value) {
                                    valueLabel = option.label;
                                    valueLabel = valueLabel.includes('_') ? valueLabel.replace('_', ' - ') : valueLabel;
                                }

                                return option.value === value;
                            });
                        });
                } else {
                    valueLabel = value.includes('_') ? value.replace('_', ' - ') : value;
                }
            }
            return valueLabel;
        },
        getValidSelectedFilters(selected) {
            const blackList = ['sortType', 'currentPage', 'pageSize', 'sortDir', 'q'];
            const filteredValue = selected.filter((item) => {
                const [code] = item.split('-');
                return !blackList.includes(code);
            });
            return filteredValue;
        },
        removeFilter(filter) {
            const selected = [...this.selected];
            selected.splice(selected.indexOf(filter), 1);
            this.selected = [...selected];
            this.updateFilter();
        },
        removeAllFilters() {
            this.selected = [];
            this.updateFilter();
        },
        updateFilter() {
            this.$scrollTo('#category-products');
            this.$router.push({
                path: this.$route.path,
                query: {
                    sortDir: this.$route.query.sortDir,
                    sortType: this.$route.query.sortType,
                    ...this.filterParams,
                    currentPage: 1,
                },
            });
        },
    },
};
